import { Box } from '@air/zephyr';
import Image from 'next/image';

import { SectionData } from '~/lib/contentful/custom-types';
import { Container } from '~/old-marketing/components/Container';
import { Section } from '~/old-marketing/components/sections/Section';
import { SectionActions } from '~/old-marketing/components/sections/SectionActions';
import { SectionContent } from '~/old-marketing/components/sections/SectionContent';
import { SectionFieldTooltip } from '~/old-marketing/components/sections/SectionFieldTooltip';
import { SectionTitle } from '~/old-marketing/components/sections/SectionTitle';
import { worthlessStudiosTheme } from '~/old-marketing/components/sections/templates/worthless-studios/theme';

const TEMPLATE_KEY = 'worthless-studios-our-projects';

export type WorthlessStudiosOurProjectsSectionTemplateProps = Pick<
  SectionData,
  'actions' | 'assets' | 'content' | 'id' | 'title'
> & {
  isPreview?: boolean;
  isSubsection?: boolean;
};

export const WorthlessStudiosOurProjectsSectionTemplate = ({
  actions,
  assets,
  content,
  id,
  isPreview,
  isSubsection,
  title,
}: WorthlessStudiosOurProjectsSectionTemplateProps) => {
  const asset = assets?.[0];

  return (
    <Section
      className={worthlessStudiosTheme}
      css={{ paddingTop: 60, paddingBottom: 60, overflow: 'visible' }}
      id={id}
      templateKey={TEMPLATE_KEY}
    >
      <Container tx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box tx={{ width: ['100%', '50%'], maxWidth: 527, mr: [0, 32], ml: [0, 'max(3.8vw, 56px)'] }}>
          {title && (
            <SectionTitle
              css={{ marginBottom: 32, colorr: '$pigeon800' }}
              isSubsection={isSubsection}
              size="heading-48"
            >
              {title}
            </SectionTitle>
          )}

          {content && (
            <SectionContent
              content={content}
              css={{
                color: '$pigeon600',
                letterSpacing: 0.05,
                lineHeight: 1.6,
              }}
              size="ui-20"
            />
          )}

          {actions && (
            <SectionActions
              actions={actions}
              css={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'stretch',
                marginTop: 40,

                a: {
                  marginBottom: 24,
                  marginRight: 0,
                },

                '@laptop': {
                  flexDirection: 'row',
                  justifyContent: 'flex-start',

                  a: {
                    marginBottom: 0,
                    marginRight: 12,
                  },
                },
              }}
            />
          )}
        </Box>

        <Box tx={{ display: ['none', 'block'], width: '50%', maxWidth: 490, mr: 56 }}>
          {asset && (
            <SectionFieldTooltip field="Assets (1)" isPreview={isPreview}>
              <Image
                height={asset.file.details.image.height}
                src={`http:${asset.file.url}`}
                width={asset.file.details.image.width}
              />
            </SectionFieldTooltip>
          )}
        </Box>
      </Container>
    </Section>
  );
};

WorthlessStudiosOurProjectsSectionTemplate.templateKey = TEMPLATE_KEY;
